import { catalogoObras } from "../../models/Colecciones.model"
import RowTabla from "./RowTabla"

export default function Listado(props: Listadoprops) {
  const n = ((props.pag * 10)-10)
  return(
    <div className="row mt-4">
      { props.lista.map( (obra, i) =>{  
        return <RowTabla 
                  n={n + (i + 1)}
                  id={obra.id} 
                  descripcion={obra.descripcion} 
                  autores={obra.autores} 
                  ISBNCompleta={obra.ISBNCompleta}
                  ISBNDigital={obra.ISBNDigital}
                  ISBNImpresa={obra.ISBNImpresa}
                  coleccion={obra.coleccion}  
                  key={i} />  
      })
      }
      </div>
  )
}

interface Listadoprops{
    lista:catalogoObras[],
    pag:number
}